import ModalDefault from "../ModalDefault";
import { IconClose } from "../icons";
import { comum } from "../../styles/Themes/light";
import {
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalMessage,
  ModalActions,
  BtnSecondary,
  BtnPrimary,
} from "./styles";

const TITLE = "Existem alterações não salvas";
const MESSAGE =
  "Você tem alterações que não foram salvas. Deseja descartar essas alterações mesmo assim?";

interface ModalConfirmDiscardProps {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
}

export default function ModalConfirmDiscard({ open, onClose, onDiscard }: ModalConfirmDiscardProps) {
  return (
    <ModalDefault
      id="modal-confirm-discard"
      openModal={open}
      onClose={onClose}
      width="470px"
      noScroll
      contentPadding="24px"
    >
      <ModalHeader>
        <ModalTitle>{TITLE}</ModalTitle>
        <ModalCloseButton type="button" onClick={onClose} aria-label="Fechar">
          <IconClose color={comum.colors.interfaceGray400} />
        </ModalCloseButton>
      </ModalHeader>
      <ModalMessage>{MESSAGE}</ModalMessage>
      <ModalActions>
        <BtnSecondary type="button" onClick={onClose}>
          Continuar editando
        </BtnSecondary>
        <BtnPrimary type="button" onClick={onDiscard}>
          Descartar
        </BtnPrimary>
      </ModalActions>
    </ModalDefault>
  );
}
